function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.767034 27.349L7.85395 19.979C6.03195 17.813 5.03302 15.087 5.03302 12.25C5.03302 5.621 10.427 0.227997 17.056 0.227997C23.685 0.227997 29.0779 5.621 29.0779 12.25C29.0779 18.879 23.685 24.272 17.056 24.272C14.567 24.272 12.196 23.522 10.168 22.097L3.02692 29.523C2.72892 29.833 2.32692 30.004 1.89692 30.004C1.48992 30.004 1.10398 29.849 0.810979 29.567C0.186979 28.967 0.168034 27.973 0.767034 27.349ZM17.056 3.36398C12.156 3.36398 8.16999 7.35 8.16999 12.25C8.16999 17.15 12.156 21.136 17.056 21.136C21.955 21.136 25.941 17.15 25.941 12.25C25.941 7.35 21.955 3.36398 17.056 3.36398Z",
  fill: "black"
});

function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.ffc07c43.svg";
export { ForwardRef as ReactComponent };